import { store } from "@betacrew/jars-flux";
import { componentKey, setStateList, setFormList, setTaxYearList, setPayerList, setStatePayrollHistoryGridData, setSelectedStatePayrollHistoryGridData, setLoadingState, setUrlFormIdParam, setUrlPayerIdParam, setSelectedState, setSelectedTaxYear, setSelectedForm, setSelectedPayer } from "./StatePayrollFilingHistorySlice";
import { all, put, takeLatest } from "redux-saga/effects";
import HistoryDataService from "../../../../services/HistoryDataService";
import General from "../../../../libs/utility/General";
import { TOASTER_VARIANT } from "../../../components/toast/constants";
import { addNotifications } from "../../toaster/ToasterPortalSlice";
import { HISTORY_LOADING_STATES } from "../Constants";

export const { getStatePayrollHistoryStates, getStatePayrollHistoryForms, getStatePayrollHistoryPayers, getStatePayrollHistoryGrid } = {
    getStatePayrollHistoryStates: (payload) => {
        return {
            type: "STATEPAYROLLFILING/GET_STATES",
            payload
        }
    },

    getStatePayrollHistoryForms: (payload) => {
        return {
            type: "STATEPAYROLLFILING/GET_FORMS",
            payload
        }
    },

    getStatePayrollHistoryPayers: (payload) => {
        return {
            type: "STATEPAYROLLFILING/GET_PAYERS",
            payload
        }
    },

    getStatePayrollHistoryGrid: (payload) => {
        return {
            type: "STATEPAYROLLFILING/GET_GRID",
            payload
        }
    },
}

function* getStatePayrollHistoryStatesAsync(action) {
    try {
        yield put(setLoadingState({ state: HISTORY_LOADING_STATES.FETCHING_STATES_LIST_LOADING, message: "Fetching Data" }));
        const { urlStateParam, urlTaxYearParam = null } = action.payload;

        const response = yield HistoryDataService.getStatePayrollStateNames();
        const { Message, Status, Data } = response?.data;

        if (Status === 1) {
            if (Data?.StateNames && Data?.TaxYears) {
                const stateList = [...Data.StateNames];
                const taxYearsList = [...Data.TaxYears];

                General.addOptionAndValueKeys(stateList, "StateName", "StateName");
                General.addOptionAndValueKeys(taxYearsList, "TaxYear", "TaxYear");

                yield all([
                    put(setStateList(stateList)),
                    put(setTaxYearList(taxYearsList))
                ]);
                if (urlStateParam) {
                    const findSelectedStateRecord = stateList.find(state => state?.value === urlStateParam)

                    if (findSelectedStateRecord) {
                        yield put(setSelectedState(findSelectedStateRecord))
                    }
                }
                if (urlTaxYearParam) {
                    const findSelectedTaxYearRecord = taxYearsList.find(taxYear => taxYear?.value === urlTaxYearParam)

                    if (findSelectedTaxYearRecord) {
                        yield put(setSelectedTaxYear(findSelectedTaxYearRecord))
                    }
                }
            } else {
                yield put(addNotifications({ heading: "Error", message: "Please try again" }));
            }
        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }
    } catch (error) {
        yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
    } finally {
        yield put(setLoadingState({ state: HISTORY_LOADING_STATES.FETCHING_STATES_LIST_READY }))
    }
}

function* getStatePayrollHistoryFormsAsync(action) {
    try {
        yield put(setLoadingState({ state: HISTORY_LOADING_STATES.FETCHING_FORMS_LIST_LOADING, message: "Fetching Data" }));
        const params = action.payload.stateNames;
        const { urlFormIdParam = null } = action.payload;
        const response = yield HistoryDataService.getStatePayrollFormNames(params)
        const { Message, Status, Data } = response?.data;

        if (Status === 1) {
            if (Data.length > 0) {
                General.addOptionAndValueKeys(Data, "FormName1", "FormId");
                yield put(setFormList(Data))
                if (urlFormIdParam) {
                    const findSelectedFormRecord = Data.find(item => item?.value == urlFormIdParam)
                    if (findSelectedFormRecord) {
                        yield put(setSelectedForm(findSelectedFormRecord))
                    }
                    yield put(setUrlFormIdParam(null));
                }
            } else {
                yield put(addNotifications({ heading: "Error", message: "Forms not found" }));
            }

        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }
    } catch (error) {
        yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
    } finally {
        yield put(setLoadingState({ state: HISTORY_LOADING_STATES.FETCHING_FORMS_LIST_READY }))
    }
}

function* getStatePayrollHistoryPayersAsync(action) {
    try {
        yield put(setLoadingState({ state: HISTORY_LOADING_STATES.FETCHING_PAYERS_LIST_LOADING, message: "Fetching Data" }));
        const { urlPayerIdParam = null } = action.payload;
        const params = action.payload.formId;
        const response = yield HistoryDataService.getStatePayrollPayerNames(params)
        const { Message, Status, Data } = response?.data;

        if (Status === 1) {
            if (Data.length > 0) {
                General.addOptionAndValueKeys(Data, "PayerName", "PayerDetailId");
                yield put(setPayerList(Data))
                if (urlPayerIdParam) {
                    const findSelectedPayerRecord = Data.find(item => item?.value == urlPayerIdParam)
                    if (findSelectedPayerRecord) {
                        yield put(setSelectedPayer(findSelectedPayerRecord))
                    }
                    yield put(setUrlPayerIdParam(null));
                }
            } else {
                yield put(addNotifications({ heading: "Error", message: "Payers not found" }));
            }

        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }
    } catch (error) {
        yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
    } finally {
        yield put(setLoadingState({ state: HISTORY_LOADING_STATES.FETCHING_PAYERS_LIST_READY }))
    }
}

function* getStatePayrollHistoryGridAsync(action) {
    try {
        yield put(setLoadingState({ state: HISTORY_LOADING_STATES.FETCHING_GRID_RECORDS_LOADING }));
        const response = yield HistoryDataService.getStatePayrollHistoryData(action.payload);
        const { Message, Status, Data } = response?.data;

        if (Status === 1) {
            if (Data.Total > 0) {
                yield put(setStatePayrollHistoryGridData([...General.extractDataFromResponseData(response?.data)]));
                yield put(setSelectedStatePayrollHistoryGridData(General.extractPaginationTotalFromResponse(response?.data)));
            }
        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }
    } catch (error) {
        yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
    } finally {
        yield put(setLoadingState({ state: HISTORY_LOADING_STATES.FETCHING_GRID_RECORDS_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getStatePayrollHistoryStates().type, getStatePayrollHistoryStatesAsync),
        takeLatest(getStatePayrollHistoryForms().type, getStatePayrollHistoryFormsAsync),
        takeLatest(getStatePayrollHistoryPayers().type, getStatePayrollHistoryPayersAsync),
        takeLatest(getStatePayrollHistoryGrid().type, getStatePayrollHistoryGridAsync)
    ]);
}
store.sagaManager.addSaga(componentKey, rootSaga);